<template>
	<div>		
		<el-menu :default-active="$route.path" class="el-menu-vertical-demo"  router :collapse="shouldCollapse"  unique-opened>			
			<template v-for="(item,index) in menu">
				<el-menu-item v-if="!item.child" :key="item.id" :index="item.href">
					<i :class="[item.icon ? item.icon : '']"></i>
					<span slot="title">{{ item.title }}</span>
				</el-menu-item>
				<el-submenu  v-else :key="item.id" :index="item.id+''">
					<template slot="title">
						<i :class="[item.icon ? item.icon :'']"></i>
						<span>{{ item.title }}</span>
					</template>				
					<MenuTree :dataList="item.child"></MenuTree>				
				</el-submenu>
			</template>				
		</el-menu>	
	</div>
</template>

<script>
	import base from '../../api/base.js'
	import store from '../../store/index'
	import MenuTree from '@/components/MenuTree'	
	export default {
		components:{
			MenuTree
		},
		props: ["isCollapse",'menu'],
		data() {
			return {				
				title: store.state.menuModule.logoInfo.logotitle,
				logo: store.state.menuModule.logoInfo.logo,
				windowWidth: window.innerWidth, // 当前窗口宽度
				breakpoint: 992 // 响应式断点（可根据需要调整）
			};
		},
		computed: {
			// 根据窗口宽度决定是否折叠
			shouldCollapse() {
				return this.windowWidth < this.breakpoint || this.isCollapse;
			}
		},
		methods: {
             // 更新窗口宽度
             updateWidth() {
             	this.windowWidth = window.innerWidth;
             }
		},
		mounted() {
			// 添加窗口大小变化监听
			window.addEventListener('resize', this.updateWidth);
		},
		beforeDestroy() {
			// 移除监听器
			window.removeEventListener('resize', this.updateWidth);
		}
	};
</script>

<style lang='less' scoped>
	 .el-menu {
		border-right: 0;
	} 
	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 200px;
		min-height: 400px;
		
	}
	.isCollapse{
		width: 64px !important;
		span{
			display:none;
			}
	}
	/* 小屏幕样式优化 */
	@media screen and (max-width: 992px) {
		.el-menu--collapse {
			width: 64px;
		}
		.el-logo {
			width: 64px;
			justify-content: center;
		}
	}
</style>